export default __webpack_public_path__ + "static/media/defaultFileIcon.01cf6e84.svg";